<!--
 * @author: YiuHai
 * @Date: 2022-03-14 16:57:25
 * @description: 统计盒子
 * @LastEditors: YiuHai
 * @LastEditTime: 2022-03-18 17:33:57
 * @FilePath: /zykyeduadmin/src/view/module/refundBoard/component/boardBox.vue
-->
<template>
  <div class="board-box" :style="{ width: `calc(${width} - 10px)` }">
    <div class="title" :class="{ primary }">
      <div>
        <span
          class="tag-color"
          v-if="tagColor"
          :style="{ background: tagColor }"
        ></span>
        <span class="sub-title" v-text="title"></span>
        <span class="unit" v-if="unit" v-text="`(${unit})`"></span>
        <el-popover
          placement="bottom-start"
          width="200"
          trigger="hover"
          :content="hint"
          v-if="hint"
        >
          <img
            slot="reference"
            class="doubt"
            v-if="primary"
            src="../images/doubt-white.png"
          />
          <img
            slot="reference"
            class="doubt"
            v-else
            src="../images/doubt.png"
          />
        </el-popover>
      </div>
      <div v-if="secondTitle">
        <span class="second-title">{{ secondTitle }}</span>
        <el-popover
          placement="bottom-start"
          width="200"
          trigger="hover"
          v-if="hint2"
          :content="hint2"
        >
          <img
            slot="reference"
            class="doubt"
            v-if="primary"
            src="../images/doubt-white.png"
          />
          <img
            slot="reference"
            class="doubt"
            v-else
            src="../images/doubt.png"
          />
        </el-popover>
      </div>
    </div>
    <div class="container">
      <div>
        <span class="label-type" :class="{ primary }">基础班</span>
        <div>
          <span :class="{ ['label-value']: primary }">{{ basisV }}</span>
          <span v-if="secondTitle" class="second-v">{{ basisV2 }}</span>
        </div>
      </div>
      <div>
        <span class="label-type" :class="{ primary }">VIP班</span>
        <div>
          <span :class="{ ['label-value']: primary }">{{ vipV }}</span>
          <span v-if="secondTitle" class="second-v">{{ vipV2 }}</span>
        </div>
      </div>
      <div class="total-sum">
        <span class="label-type" :class="{ primary }">全部班型</span>
        <div>
          <span :class="{ ['primary-value']: primary }" class="bold">{{
            countV
          }}</span>
          <span v-if="secondTitle" class="second-v bold">{{ countV2 }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    primary: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    secondTitle: {
      type: String,
      default: "",
    },
    unit: {
      type: String,
      default: "",
    },
    width: {
      type: String,
      default: "",
    },
    tagColor: {
      type: String,
      default: null,
    },
    basisV: [String, Number],
    vipV: [String, Number],
    countV: [String, Number],

    basisV2: [String, Number],
    vipV2: [String, Number],
    countV2: [String, Number],

    hint: {
      type: String,
      default: "",
    },
    hint2: {
      type: String,
      default: "",
    },
  },
  computed: {},
};
</script>

<style lang="scss">
$primaryColor: rgba(44, 133, 255, 1);
.board-box {
  display: inline-block;
  background: #fff;
  border-radius: 4px;
  overflow: hidden;
  cursor: pointer;
  user-select: none;
  box-shadow: 0 0 3px #ccc;
  margin-right: 10px;
  margin-bottom: 5px;
  box-sizing: border-box;
  &:hover {
    box-shadow: 0 0 10px #ccc;
  }

  .title {
    padding: 10px 12px;
    color: rgba(47, 47, 47, 1);
    font-size: 14px;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .tag-color {
      width: 10px;
      height: 10px;
      margin-right: 2px;
      display: inline-block;
      border-radius: 50%;
    }
    .sub-title {
      font-size: 16px;
    }

    &.primary {
      color: #fff;
      background: rgba(44, 133, 255, 1);
      .unit {
        color: #fff;
      }
    }

    .doubt {
      width: 20px;
      margin-left: 3px;
      vertical-align: middle;
    }

    .unit {
      display: inline-block;
      font-size: 12px;
      margin-left: 3px;
      font-weight: initial;
      color: #9c9c9c;
    }

    .second-title {
      color: #9c9c9c;
      font-size: 12px;
      font-weight: 400;
    }
  }

  .container {
    padding: 8px 12px;
    > div {
      display: flex;
      justify-content: space-between;
      padding: 8px 0;
    }

    .total-sum {
      border-top: 1px rgba(244, 244, 244, 1) solid;
      margin-top: 10px;
      height: 30px;
      margin-bottom: 10px;

      .label-type {
        &.primary {
          font-weight: bold;
        }
      }

      .primary-value {
        color: $primaryColor;
        font-weight: bold;
        font-size: 20px;
      }
    }
    span {
      font-size: 16px;
    }

    .label-type {
      color: rgba(156, 156, 156, 1);
      font-size: 14px;

      &.primary {
        color: rgba(47, 47, 47, 1);
      }

      & + .label-value {
        color: rgba(47, 47, 47, 1);
        font-weight: bold;
      }
    }

    .second-v {
      display: inline-block;
      width: 66px;
      background: #f4f4f4;
      margin-left: 10px;
      text-align: center;
      color: #2f2f2f;
      border-radius: 4px;
      padding: 0 5px;
      font-size: 16px;
    }
  }

  .bold {
    font-weight: bold;
  }
}
</style>
